/**
 * The possible values for the `hx-swap` attribute
 */
var SwapValue;
(function (SwapValue) {
    /**
     * Replace the inner html of the target element
     */
    SwapValue["InnerHTML"] = "innerHTML";
    /**
     * Replace the entire target element with the response
     */
    SwapValue["OuterHTML"] = "outerHTML";
    /**
     * Replace the text content of the target element, without parsing the response as HTML
     */
    SwapValue["TextContent"] = "textContent";
    /**
     * Insert the response before the target element
     */
    SwapValue["Beforebegin"] = "beforebegin";
    /**
     * Insert the response before the first child of the target element
     */
    SwapValue["Afterbegin"] = "afterbegin";
    /**
     * Insert the response after the last child of the target element
     */
    SwapValue["Beforeend"] = "beforeend";
    /**
     * Insert the response after the target element
     */
    SwapValue["Afterend"] = "afterend";
    /**
     * Deletes the target element regardless of the response
     */
    SwapValue["Delete"] = "delete";
    /**
     * Does not append content from response (out of band items will still be processed).
     */
    SwapValue["None"] = "none";
})(SwapValue || (SwapValue = {}));
/**
 * Event names without the `htmx:` prefix
 */
var EventName;
(function (EventName) {
    /**
     * send this event to an element to abort a request
     */
    EventName["Abort"] = "abort";
    /**
     * triggered after an AJAX request has completed processing a successful response
     */
    EventName["AfterOnLoad"] = "afterOnLoad";
    /**
     * triggered after htmx has initialized a node
     */
    EventName["AfterProcessNode"] = "afterProcessNode";
    /**
     * triggered after an AJAX request has completed
     */
    EventName["AfterRequest"] = "afterRequest";
    /**
     * triggered after the DOM has settled
     */
    EventName["AfterSettle"] = "afterSettle";
    /**
     * triggered after new content has been swapped in
     */
    EventName["AfterSwap"] = "afterSwap";
    /**
     * triggered before htmx disables an element or removes it from the DOM
     */
    EventName["BeforeCleanupElement"] = "beforeCleanupElement";
    /**
     * triggered before any response processing occurs
     */
    EventName["BeforeOnLoad"] = "beforeOnLoad";
    /**
     * triggered before htmx initializes a node
     */
    EventName["BeforeProcessNode"] = "beforeProcessNode";
    /**
     * triggered before an AJAX request is made
     */
    EventName["BeforeRequest"] = "beforeRequest";
    /**
     * triggered before a swap is done, allows you to configure the swap
     */
    EventName["BeforeSwap"] = "beforeSwap";
    /**
     * triggered just before an ajax request is sent
     */
    EventName["BeforeSend"] = "beforeSend";
    /**
     * triggered before the View Transition wrapped swap occurs
     */
    EventName["BeforeTransition"] = "beforeTransition";
    /**
     * triggered before the request, allows you to customize parameters, headers
     */
    EventName["ConfigRequest"] = "configRequest";
    /**
     * triggered after a trigger occurs on an element, allows you to cancel (or delay) issuing the AJAX request
     */
    EventName["Confirm"] = "confirm";
    /**
     * triggered on an error during cache writing
     */
    EventName["HistoryCacheError"] = "historyCacheError";
    /**
     * triggered on a cache miss in the history subsystem
     */
    EventName["HistoryCacheMiss"] = "historyCacheMiss";
    /**
     * triggered on a unsuccessful remote retrieval
     */
    EventName["HistoryCacheMissError"] = "historyCacheMissError";
    /**
     * triggered on a successful remote retrieval
     */
    EventName["HistoryCacheMissLoad"] = "historyCacheMissLoad";
    /**
     * triggered when htmx handles a history restoration action
     */
    EventName["HistoryRestore"] = "historyRestore";
    /**
     * triggered before content is saved to the history cache
     */
    EventName["BeforeHistorySave"] = "beforeHistorySave";
    /**
     * triggered when new content is added to the DOM
     */
    EventName["Load"] = "load";
    /**
     * triggered when an element refers to a SSE event in its trigger, but no parent SSE source has been defined
     */
    EventName["NoSSESourceError"] = "noSSESourceError";
    /**
     * triggered when an exception occurs during the onLoad handling in htmx
     */
    EventName["OnLoadError"] = "onLoadError";
    /**
     * triggered after an out of band element as been swapped in
     */
    EventName["OOBAfterSwap"] = "oobAfterSwap";
    /**
     * triggered before an out of band element swap is done, allows you to configure the swap
     */
    EventName["OOBBeforeSwap"] = "oobBeforeSwap";
    /**
     * triggered when an out of band element does not have a matching ID in the current DOM
     */
    EventName["OOBErrorNoTarget"] = "oobErrorNoTarget";
    /**
     * triggered after a prompt is shown
     */
    EventName["Prompt"] = "prompt";
    /**
     * triggered after a url is pushed into history
     */
    EventName["PushedIntoHistory"] = "pushedIntoHistory";
    /**
     * triggered after a url is replaced in history
     */
    EventName["ReplacedInHistory"] = "replacedInHistory";
    /**
     * triggered when an HTTP response error (non-200 or 300 response code) occurs
     */
    EventName["ResponseError"] = "responseError";
    /**
     * triggered when a request is aborted
     */
    EventName["SendAbort"] = "sendAbort";
    /**
     * triggered when a network error prevents an HTTP request from happening
     */
    EventName["SendError"] = "sendError";
    /**
     * triggered when an error occurs with a SSE source
     */
    EventName["SseError"] = "sseError";
    /**
     * triggered when a SSE source is opened
     */
    EventName["SSEOpen"] = "sseOpen";
    /**
     * triggered when an error occurs during the swap phase
     */
    EventName["SwapError"] = "swapError";
    /**
     * triggered when an invalid target is specified
     */
    EventName["TargetError"] = "targetError";
    /**
     * triggered when a request timeout occurs
     */
    EventName["Timeout"] = "timeout";
    /**
     * triggered before an element is validated
     */
    EventName["ValidationValidate"] = "validation:validate";
    /**
     * triggered when an element fails validation
     */
    EventName["ValidationFailed"] = "validation:failed";
    /**
     * triggered when a request is halted due to validation errors
     */
    EventName["ValidationHalted"] = "validation:halted";
    /**
     * triggered when an ajax request aborts
     */
    EventName["XhrAbort"] = "xhr:abort";
    /**
     * triggered when an ajax request ends
     */
    EventName["XhrLoadend"] = "xhr:loadend";
    /**
     * triggered when an ajax request starts
     */
    EventName["XhrLoadstart"] = "xhr:loadstart";
    /**
     * triggered periodically during an ajax request that supports progress events
     */
    EventName["XhrProgress"] = "xhr:progress";
})(EventName || (EventName = {}));
(function (EventName) {
    /**
     * Attribute suffixes in kebab case without the `htmx:` prefix
     */
    let KebabCase;
    (function (KebabCase) {
        /**
         * send this event to an element to abort a request
         */
        KebabCase["Abort"] = "abort";
        /**
         * triggered after an AJAX request has completed processing a successful response
         */
        KebabCase["AfterOnLoad"] = "after-on-load";
        /**
         * triggered after htmx has initialized a node
         */
        KebabCase["AfterProcessNode"] = "after-process-node";
        /**
         * triggered after an AJAX request has completed
         */
        KebabCase["AfterRequest"] = "after-request";
        /**
         * triggered after the DOM has settled
         */
        KebabCase["AfterSettle"] = "after-settle";
        /**
         * triggered after new content has been swapped in
         */
        KebabCase["AfterSwap"] = "after-swap";
        /**
         * triggered before htmx disables an element or removes it from the DOM
         */
        KebabCase["BeforeCleanupElement"] = "before-cleanup-element";
        /**
         * triggered before any response processing occurs
         */
        KebabCase["BeforeOnLoad"] = "before-on-load";
        /**
         * triggered before htmx initializes a node
         */
        KebabCase["BeforeProcessNode"] = "before-process-node";
        /**
         * triggered before an AJAX request is made
         */
        KebabCase["BeforeRequest"] = "before-request";
        /**
         * triggered before a swap is done, allows you to configure the swap
         */
        KebabCase["BeforeSwap"] = "before-swap";
        /**
         * triggered just before an ajax request is sent
         */
        KebabCase["BeforeSend"] = "before-send";
        /**
         * triggered before the View Transition wrapped swap occurs
         */
        KebabCase["BeforeTransition"] = "before-transition";
        /**
         * triggered before the request, allows you to customize parameters, headers
         */
        KebabCase["ConfigRequest"] = "config-request";
        /**
         * triggered after a trigger occurs on an element, allows you to cancel (or delay) issuing the AJAX request
         */
        KebabCase["Confirm"] = "confirm";
        /**
         * triggered on an error during cache writing
         */
        KebabCase["HistoryCacheError"] = "history-cache-error";
        /**
         * triggered on a cache miss in the history subsystem
         */
        KebabCase["HistoryCacheMiss"] = "history-cache-miss";
        /**
         * triggered on a unsuccessful remote retrieval
         */
        KebabCase["HistoryCacheMissError"] = "history-cache-miss-error";
        /**
         * triggered on a successful remote retrieval
         */
        KebabCase["HistoryCacheMissLoad"] = "history-cache-miss-load";
        /**
         * triggered when htmx handles a history restoration action
         */
        KebabCase["HistoryRestore"] = "history-restore";
        /**
         * triggered before content is saved to the history cache
         */
        KebabCase["BeforeHistorySave"] = "before-history-save";
        /**
         * triggered when new content is added to the DOM
         */
        KebabCase["Load"] = "load";
        /**
         * triggered when an element refers to a SSE event in its trigger, but no parent SSE source has been defined
         */
        KebabCase["NoSSESourceError"] = "no-sse-source-error";
        /**
         * triggered when an exception occurs during the onLoad handling in htmx
         */
        KebabCase["OnLoadError"] = "on-load-error";
        /**
         * triggered after an out of band element as been swapped in
         */
        KebabCase["OOBAfterSwap"] = "oob-after-swap";
        /**
         * triggered before an out of band element swap is done, allows you to configure the swap
         */
        KebabCase["OOBBeforeSwap"] = "oob-before-swap";
        /**
         * triggered when an out of band element does not have a matching ID in the current DOM
         */
        KebabCase["OOBErrorNoTarget"] = "oob-error-no-target";
        /**
         * triggered after a prompt is shown
         */
        KebabCase["Prompt"] = "prompt";
        /**
         * triggered after a url is pushed into history
         */
        KebabCase["PushedIntoHistory"] = "pushed-into-history";
        /**
         * triggered after a url is replaced in history
         */
        KebabCase["ReplacedInHistory"] = "replaced-in-history";
        /**
         * triggered when an HTTP response error (non-200 or 300 response code) occurs
         */
        KebabCase["ResponseError"] = "response-error";
        /**
         * triggered when a request is aborted
         */
        KebabCase["SendAbort"] = "send-abort";
        /**
         * triggered when a network error prevents an HTTP request from happening
         */
        KebabCase["SendError"] = "send-error";
        /**
         * triggered when an error occurs with a SSE source
         */
        KebabCase["SseError"] = "sse-error";
        /**
         * triggered when a SSE source is opened
         */
        KebabCase["SSEOpen"] = "sse-open";
        /**
         * triggered when an error occurs during the swap phase
         */
        KebabCase["SwapError"] = "swap-error";
        /**
         * triggered when an invalid target is specified
         */
        KebabCase["TargetError"] = "target-error";
        /**
         * triggered when a request timeout occurs
         */
        KebabCase["Timeout"] = "timeout";
        /**
         * triggered before an element is validated
         */
        KebabCase["ValidationValidate"] = "validation:validate";
        /**
         * triggered when an element fails validation
         */
        KebabCase["ValidationFailed"] = "validation:failed";
        /**
         * triggered when a request is halted due to validation errors
         */
        KebabCase["ValidationHalted"] = "validation:halted";
        /**
         * triggered when an ajax request aborts
         */
        KebabCase["XhrAbort"] = "xhr:abort";
        /**
         * triggered when an ajax request ends
         */
        KebabCase["XhrLoadend"] = "xhr:loadend";
        /**
         * triggered when an ajax request starts
         */
        KebabCase["XhrLoadstart"] = "xhr:loadstart";
        /**
         * triggered periodically during an ajax request that supports progress events
         */
        KebabCase["XhrProgress"] = "xhr:progress";
    })(KebabCase = EventName.KebabCase || (EventName.KebabCase = {}));
})(EventName || (EventName = {}));
/**
 * Attribute names without the `hx-` prefix
 */
var AttributeName;
(function (AttributeName) {
    // Core Attributes
    /**
     * Issues a GET to the specified URL
     *
     * @see {@link https://htmx.org/attributes/hx-get/}
     */
    AttributeName["Get"] = "get";
    /**
     * Issues a POST to the specified URL
     *
     * @see {@link https://htmx.org/attributes/hx-post/}
     */
    AttributeName["Post"] = "post";
    /**
     * Handle events with inline scripts on elements
     *
     * @see {@link https://htmx.org/attributes/hx-on/}
     */
    AttributeName["On"] = "on";
    /**
     * Push a URL into the browser location bar to create history
     *
     * @see {@link https://htmx.org/attributes/hx-push-url/}
     */
    AttributeName["PushUrl"] = "push-url";
    /**
     * Select content to swap in from a response
     *
     * @see {@link https://htmx.org/attributes/hx-select/}
     */
    AttributeName["Select"] = "select";
    /**
     * Select content to swap in from a response, somewhere other than the target (out of band)
     *
     * @see {@link https://htmx.org/attributes/hx-select-oob/}
     */
    AttributeName["SelectOob"] = "select-oob";
    /**
     * Controls how content will swap in (outerHTML, beforeend, afterend, …)
     *
     * @see {@link https://htmx.org/attributes/hx-swap/}
     */
    AttributeName["Swap"] = "swap";
    /**
     * Mark element to swap in from a response (out of band)
     *
     * @see {@link https://htmx.org/attributes/hx-swap-oob/}
     */
    AttributeName["SwapOob"] = "swap-oob";
    /**
     * Specifies the target element to be swapped
     *
     * @see {@link https://htmx.org/attributes/hx-target/}
     */
    AttributeName["Target"] = "target";
    /**
     * Specifies the event that triggers the request
     *
     * @see {@link https://htmx.org/attributes/hx-trigger/}
     */
    AttributeName["Trigger"] = "trigger";
    /**
     * Add values to submit with the request (JSON format)
     *
     * @see {@link https://htmx.org/attributes/hx-vals/}
     */
    AttributeName["Vals"] = "vals";
    // Additional Attributes
    /**
     * Add progressive enhancement for links and forms
     *
     * @see {@link https://htmx.org/attributes/hx-boost/}
     */
    AttributeName["Boost"] = "boost";
    /**
     * Shows a confirm() dialog before issuing a request
     *
     * @see {@link https://htmx.org/attributes/hx-confirm/}
     */
    AttributeName["Confirm"] = "confirm";
    /**
     * Issues a DELETE to the specified URL
     *
     * @see {@link https://htmx.org/attributes/hx-delete/}
     */
    AttributeName["Delete"] = "delete";
    /**
     * Disables htmx processing for the given node and any children nodes
     *
     * @see {@link https://htmx.org/attributes/hx-disable/}
     */
    AttributeName["Disable"] = "disable";
    /**
     * Adds the disabled attribute to the specified elements while a request is in flight
     *
     * @see {@link https://htmx.org/attributes/hx-disabled-elt/}
     */
    AttributeName["DisabledElt"] = "disabled-elt";
    /**
     * Control and disable automatic attribute inheritance for child nodes
     *
     * @see {@link https://htmx.org/attributes/hx-disinherit/}
     */
    AttributeName["Disinherit"] = "disinherit";
    /**
     * Changes the request encoding type
     *
     * @see {@link https://htmx.org/attributes/hx-encoding/}
     */
    AttributeName["Encoding"] = "encoding";
    /**
     * Extensions to use for this element
     *
     * @see {@link https://htmx.org/attributes/hx-ext/}
     */
    AttributeName["Ext"] = "ext";
    /**
     * Adds to the headers that will be submitted with the request
     *
     * @see {@link https://htmx.org/attributes/hx-headers/}
     */
    AttributeName["Headers"] = "headers";
    /**
     * Prevent sensitive data being saved to the history cache
     *
     * @see {@link https://htmx.org/attributes/hx-history/}
     */
    AttributeName["History"] = "history";
    /**
     * The element to snapshot and restore during history navigation
     *
     * @see {@link https://htmx.org/attributes/hx-history-elt/}
     */
    AttributeName["HistoryElt"] = "history-elt";
    /**
     * Include additional data in requests
     *
     * @see {@link https://htmx.org/attributes/hx-include/}
     */
    AttributeName["Include"] = "include";
    /**
     * The element to put the htmx-request class on during the request
     *
     * @see {@link https://htmx.org/attributes/hx-indicator/}
     */
    AttributeName["Indicator"] = "indicator";
    /**
     * Control and enable automatic attribute inheritance for child nodes if it has been disabled by default
     *
     * @see {@link https://htmx.org/attributes/hx-inherit/}
     */
    AttributeName["Inherit"] = "inherit";
    /**
     * Filters the parameters that will be submitted with a request
     *
     * @see {@link https://htmx.org/attributes/hx-params/}
     */
    AttributeName["Params"] = "params";
    /**
     * Issues a PATCH to the specified URL
     *
     * @see {@link https://htmx.org/attributes/hx-patch/}
     */
    AttributeName["Patch"] = "patch";
    /**
     * Specifies elements to keep unchanged between requests
     *
     * @see {@link https://htmx.org/attributes/hx-preserve/}
     */
    AttributeName["Preserve"] = "preserve";
    /**
     * Shows a prompt() before submitting a request
     *
     * @see {@link https://htmx.org/attributes/hx-prompt/}
     */
    AttributeName["Prompt"] = "prompt";
    /**
     * Issues a PUT to the specified URL
     *
     * @see {@link https://htmx.org/attributes/hx-put/}
     */
    AttributeName["Put"] = "put";
    /**
     * Replace the URL in the browser location bar
     *
     * @see {@link https://htmx.org/attributes/hx-replace-url/}
     */
    AttributeName["ReplaceUrl"] = "replace-url";
    /**
     * Configures various aspects of the request
     *
     * @see {@link https://htmx.org/attributes/hx-request/}
     */
    AttributeName["Request"] = "request";
    /**
     * Control how requests made by different elements are synchronized
     *
     * @see {@link https://htmx.org/attributes/hx-sync/}
     */
    AttributeName["Sync"] = "sync";
    /**
     * Force elements to validate themselves before a request
     *
     * @see {@link https://htmx.org/attributes/hx-validate/}
     */
    AttributeName["Validate"] = "validate";
    /**
     * Adds values dynamically to the parameters to submit with the request (deprecated, please use hx-vals)
     *
     * @see {@link https://htmx.org/attributes/hx-vars/}
     */
    AttributeName["Vars"] = "vars";
})(AttributeName || (AttributeName = {}));
const attributeNames = Object.values(AttributeName);
export function isHtmxAttributeName(value) {
    return attributeNames.includes(value);
}
function createHistoryAttributeDeclaration([history,]) {
    return {
        name: `hx-${AttributeName.History}`,
        value: history === false ? "false" : null,
    };
}
function createJsonObjectAttributeDeclaration(name, [jsonObject]) {
    return {
        name: `hx-${name}`,
        value: jsonObject ?? null,
    };
}
function createDefaultAttributeDeclaration(name, params) {
    let value;
    let suffix;
    if (params.length === 1) {
        value = params[0];
    }
    else {
        suffix = params[0];
        value = params[1];
    }
    return {
        name: suffix ? `hx-${name}:${suffix}` : `hx-${name}`,
        value,
    };
}
export function hx(name, ...params) {
    switch (name) {
        case AttributeName.History: {
            return createHistoryAttributeDeclaration(params);
        }
        case AttributeName.Request:
        case AttributeName.Vals: {
            return createJsonObjectAttributeDeclaration(name, params);
        }
        case AttributeName.HistoryElt:
        case AttributeName.On:
        case AttributeName.Swap:
        default: {
            return createDefaultAttributeDeclaration(name, params);
        }
    }
}
